export const fonts = {
    inter: {
        black: 'Inter-Black',
        bold: 'Inter-Bold',
        extraBold: 'Inter-ExtraBold',
        extraLight: 'Inter-ExtraLight',
        light: 'Inter-Light',
        medium: 'Inter-Medium',
        regular: 'Inter-Regular',
        semiBold: 'Inter-SemiBold',
        thin: 'Inter-Thin'
    },
    pretendard: {
        black: 'Pretendard-Black',
        bold: 'Pretendard-Bold',
        extraBold: 'Pretendard-ExtraBold',
        extraLight: 'Pretendard-ExtraLight',
        light: 'Pretendard-Light',
        medium: 'Pretendard-Medium',
        regular: 'Pretendard-Regular',
        semiBold: 'Pretendard-SemiBold',
        thin: 'Pretendard-Thin'
    }
}

function getFont() {
    // const currentLanguage = "en"

    // if (currentLanguage == "ko") return fonts.pretendard
    return fonts.inter
}

export const typography = {
    large_title: {
        "34": {
            fontWeight: 600,
            fontSize: 34,
            lineHeight: "40px",
            letterSpacing: 0
        },
        "32": {
            fontWeight: 600,
            fontSize: 32,
            lineHeight: "40px",
            letterSpacing: 0
        }
    },
    title: {
        l_28_medium: {
            fontWeight: 500,
            fontSize: 26,
            lineHeight: "36px",
            letterSpacing: 0
        },
        m_24_medium: {
            fontWeight: 500,
            fontSize: 24,
            lineHeight: "36px",
            letterSpacing: 0
        },
        m_22_medium: {
            fontWeight: 500,
            fontSize: 22,
            lineHeight: "32px",
            letterSpacing: 0
        },
        s_18_bold: {
            fontWeight: 700,
            fontSize: 18,
            lineHeight: "30px",
            letterSpacing: 0
        },
        s_18_medium: {
            fontWeight: 500,
            fontSize: 18,
            lineHeight: '30px',
            letterSpacing: 0
        }
    },
    headline: {
        "16_regular": {
            fontWeight: 400,
            fontSize: 16,
            lineHeight: "24px",
            letterSpacing: 0
        }
    },
    body: {
        "15_medium": {
            fontWeight: 500,
            fontSize: 15,
            lineHeight: "22px",
            letterSpacing: 0
        },
        "15_regular": {
            fontWeight: 400,
            fontSize: 15,
            lineHeight: "22px",
            letterSpacing: 0
        },
        "14_regular": {
            fontWeight: 400,
            fontSize: 14,
            lineHeight: "22px",
            letterSpacing: 0
        }
    },
    "footnote_13": {
        fontWeight: 400,
        fontSize: 13,
        lineHeight: "19px",
        letterSpacing: 0
    },
    "caption_12_regular": {
        fontWeight: 400,
        fontSize: 12,
        lineHeight: "18px",
        letterSpacing: 0
    },
    "caption_12_light": {
        fontFamily: getFont().light,
        fontSize: 12,
        lineHeight: "18px",
        letterSpacing: 0
    },
    "label_11_regular": {
        fontWeight: 400,
        fontSize: 11,
        lineHeight: "16px",
        letterSpacing: 0
    },
}

const typography_old = {
    title: {
        bold_42: {
            fontWeight: 700,
            fontSize: 42,
            lineHeight: 58,
            letterSpacing: 0
        },
        bold_32: {
            fontWeight: 700,
            fontSize: 32,
            lineHeight: 40,
            letterSpacing: 0
        },
        bold_24: {
            fontWeight: 700,
            fontSize: 24,
            lineHeight: 36,
            letterSpacing: 0
        },
        medium_24: {
            fontWeight: 500,
            fontSize: 24,
            lineHeight: 36,
            letterSpacing: 0
        },
        regular_24: {
            fontWeight: 400,
            fontSize: 24,
            lineHeight: 36,
            letterSpacing: 0
        }
    },
    subtitle: {
        bold_20: {
            fontWeight: 700,
            fontSize: 20,
            lineHeight: 24,
            letterSpacing: 0
        },
        medium_20: {
            fontWeight: 500,
            fontSize: 20,
            lineHeight: 24,
            letterSpacing: 0
        },
        bold_18: {
            fontWeight: 700,
            fontSize: 18,
            lineHeight: 22,
            letterSpacing: 0
        },
        semibold_18: {
            fontWeight: 600,
            fontSize: 18,
            lineHeight: 22,
            letterSpacing: 0
        },
        medium_18: {
            fontWeight: 500,
            fontSize: 18,
            lineHeight: 22,
            letterSpacing: 0
        },
        regular_18: {
            fontWeight: 400,
            fontSize: 18,
            lineHeight: 22,
            letterSpacing: 0
        },
        semibold_16: {
            fontWeight: 600,
            fontSize: 16,
            lineHeight: 20,
            letterSpacing: 0
        }
    },
    body: {
        medium_16: {
            fontWeight: 500,
            fontSize: 16,
            lineHeight: 24,
            letterSpacing: 0
        },
        regular_16: {
            fontWeight: 400,
            fontSize: 16,
            lineHeight: 24,
            letterSpacing: 0
        },
        semiBold_15: {
            fontWeight: 600,
            fontSize: 14,
            lineHeight: 23,
            letterSpacing: 0
        },
        medium_15: {
            fontWeight: 400,
            fontSize: 15,
            lineHeight: 23,
            letterSpacing: 0
        },
        regular_15: {
            fontWeight: 400,
            fontSize: 15,
            lineHeight: 22,
            letterSpacing: 0
        },
        medium_14: {
            fontWeight: 500,
            fontSize: 14,
            lineHeight: 22,
            letterSpacing: 0
        },
        regular_14: {
            fontWeight: 400,
            fontSize: 14,
            lineHeight: 22,
            letterSpacing: 0
        },
    },
    caption: {
        medium_12: {
            fontWeight: 500,
            fontSize: 12,
            lineHeight: 20,
            letterSpacing: 0
        },
        regular_12: {
            fontWeight: 400,
            fontSize: 12,
            lineHeight: 20,
            letterSpacing: 0
        }
    },
    action: {
        regular_14: {
            fontWeight: 500,
            fontSize: 14,
            lineHeight: 18,
            letterSpacing: 0
        },
        link_14: {
            fontWeight: 600,
            fontSize: 14,
            lineHeight: 18,
            letterSpacing: 0
        },
        button_12: {
            fontWeight: 500,
            fontSize: 12,
            lineHeight: 16,
            letterSpacing: 0
        }
    }
}

export default typography_old